import script from "./DetailListInvoiceProxySP1.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailListInvoiceProxySP1.vue?vue&type=script&setup=true&lang=js"

import "./DetailListInvoiceProxySP1.vue?vue&type=style&index=0&id=6a0d3836&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0d3836"]])

export default __exports__